
/* eslint max-classes-per-file: ["error", 2] */

import { defineComponent, ref, computed } from 'vue';
import PopTable from './PopTable.vue';

export interface ButtonID {
  rowID: number;
  buttonID: number;
}

export class PopRowState {
  public ButtonStates: Array<boolean> = [];

  constructor(numElements: number) {
    this.ButtonStates = Array(numElements);
    this.ButtonStates.fill(false);
  }

  clickButton(buttonID: number) : void{
    this.ButtonStates[buttonID] = true;
  }

  getFilled() : boolean {
    return !(this.ButtonStates.includes(false));
  }

  clearAll() : void {
    for (let i = 0; i < this.ButtonStates.length; i += 1) {
      this.ButtonStates[i] = false;
    }
  }
}

export class PopTableState {
  public RowState: Array<PopRowState> = [];
  public currActiveRow = -1;
  public winner = -1;

  constructor(initRows: number, initElements: number) {
    for (let i = 0; i < initRows; i += 1) {
      this.RowState.push(new PopRowState(initElements));
    }
  }
  clickButton(buttonLoc: ButtonID, playerTurn : number) : void{
    this.RowState[buttonLoc.rowID].clickButton(buttonLoc.buttonID);

    let finished = true;
    for (let i = 0; i < this.RowState.length; i += 1) {
      if (!this.RowState[i].getFilled()) {
        finished = false;
      }
    }

    if (finished) {
      this.winner = (playerTurn === 1) ? 2 : 1;
    }
  }

  clearActiveRow() : void{
    this.currActiveRow = -1;
  }

  // return true if currently no active row
  setActiveRow(rowID: number) : boolean {
    if (this.currActiveRow === -1) {
      this.currActiveRow = rowID;
      return true;
    }
    return (rowID === this.currActiveRow);
  }

  getButtonState(buttonID : ButtonID) : boolean {
    return this.RowState[buttonID.rowID].ButtonStates[buttonID.buttonID];
  }

  clearAll() :void {
    for (let i = 0; i < this.RowState.length; i += 1) {
      this.RowState[i].clearAll();
    }
    this.clearActiveRow();
    this.winner = -1;
  }
}
export const tableRef = ref(new PopTableState(3, 3));
export const playerTurn = ref(1);

const __default__ = defineComponent({
  name: 'PopBoard',
  components: {
    PopTable,
  },
  data() {
    return {
      playerTurn: playerTurn.value,
      // yes I am aware that these two are basically the same but they're used in different places
      colorHover: computed(() => (tableRef.value.currActiveRow === -1 ? '#1095c1' : '#1ab3e6')),
      colorActive: computed(() => (tableRef.value.currActiveRow === -1 ? '#1095c1' : '#37bae6')),
      switchDisabled: computed(() => (tableRef.value.currActiveRow === -1)),
    };
  },

  methods: {
    onSwitchClick() {
      if (tableRef.value.currActiveRow === -1) return;
      if (playerTurn.value === 1) {
        playerTurn.value = 2;
      } else {
        playerTurn.value = 1;
      }
      tableRef.value.clearActiveRow();
    },
    getPlayer() {
      return playerTurn.value;
    },
    getPlayerWon() {
      return tableRef.value.winner;
    },
    clearAll() {
      tableRef.value.clearAll();
      playerTurn.value = 1;
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "1b2032b0": (_ctx.colorHover),
  "4ef10f1a": (_ctx.colorActive)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__